export const ENV = {
    get ApiEntryPoint() {
        return process.env.API_ENTRY_POINT;
    },
    get ApiEntryPointBet() {
        return process.env.API_ENTRY_POINT_BET;
    },
    get ApiEntryPointV3() {
        return process.env.API_ENTRY_POINT_V3;
    },
    get WSocket() {
        return process.env.WEB_SOCKET || '';
    },
    getGtmIdVoltaDesktop() {
        return process.env.GTM_ID_VOLTA_DESKTOP || '';
    },
};
